import { CarouselSidebarProps } from './types'
import { ImageryContentFragment } from '../../types'
import SlideInfo from '../SlideInfo'

const CarouselSidebar = ({
  carouselItems,
  activeItem,
  handleOnClick,
  duration,
  pause,
  ruleExpression = '',
  condition,
  ruleType,
  tokenProperties
}: CarouselSidebarProps) => {
  return (
    <div className='carousel-sidebar-info'>
      {carouselItems?.map((item: ImageryContentFragment, index) => {
        return (
          <SlideInfo
            key={`${item.id}_slideinfo_${index}`}
            {...item}
            activeItem={activeItem}
            handleOnClick={handleOnClick}
            duration={duration}
            pause={pause}
            ruleExpression={ruleExpression}
            ruleType={ruleType}
            condition={condition}
            slideIndex={index}
            tokenProperties={tokenProperties}
            id={item?.id}
          />
        )
      })}
    </div>
  )
}

export default CarouselSidebar
